import { render } from "./OrderList.vue?vue&type=template&id=1ba522aa&scoped=true"
import script from "./OrderList.vue?vue&type=script&lang=js"
export * from "./OrderList.vue?vue&type=script&lang=js"

import "./OrderList.vue?vue&type=style&index=0&id=1ba522aa&lang=scss&scoped=true"

import exportComponent from "/Users/adostos/wame/zealy-web-2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba522aa"]])

export default __exports__